import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    [theme.breakpoints.down("md")]: {
      // Для планшета (≤900px)
      fontSize: "0.9rem", // 40px при базовом 16px
    },
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    [theme.breakpoints.down("sm")]: {
      // Для планшета (≤900px)
      fontSize: "0.6rem", // 40px при базовом 16px
    },
  },
  [`&.${tableCellClasses.body}`]: {
    [theme.breakpoints.down("md")]: {
      // Для планшета (≤900px)
      fontSize: "0.9rem", // 40px при базовом 16px
    },
  },
  [`&.${tableCellClasses.body}`]: {
    [theme.breakpoints.down("sm")]: {
      // Для планшета (≤900px)
      fontSize: "0.6rem", // 40px при базовом 16px
    },
  },
  // padding: theme.spacing(2),
  // margin: theme.spacing(0),
  padding: "1px",
  margin: "1px",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({ data }) {
  return (
    <TableContainer>
      <Table sx={{ width: "100%" }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Движение</StyledTableCell>
            <StyledTableCell align="center">Результат</StyledTableCell>
            <StyledTableCell align="center">Имя рекордсмена</StyledTableCell>
            {/* <StyledTableCell align="right">Дата рекорда</StyledTableCell> */}
            <StyledTableCell align="center">Место рекорда</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <>
              <StyledTableRow>
                <StyledTableCell align="center" colSpan={4}>
                  <b>{row.category}</b>
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell component="th" scope="row" variant="head">
                  Приседание
                </StyledTableCell>
                <StyledTableCell align="center">{row.bench}</StyledTableCell>
                <StyledTableCell align="center">
                  {row.bench_name}
                </StyledTableCell>
                {/* <StyledTableCell align="right">
                  {row.bench_date}
                </StyledTableCell> */}
                <StyledTableCell align="center">
                  {row.bench_place}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell component="th" scope="row" variant="head">
                  жим
                </StyledTableCell>
                <StyledTableCell align="center">{row.press}</StyledTableCell>
                <StyledTableCell align="center">
                  {row.press_name}
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  {row.press_date}
                </StyledTableCell> */}
                <StyledTableCell align="center">
                  {row.press_place}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell component="th" scope="row" variant="head">
                  Тяга
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.dead_lift}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {row.dead_lift_name}
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  {row.dead_lift_date}
                </StyledTableCell> */}
                <StyledTableCell align="center">
                  {row.dead_lift_place}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell component="th" scope="row" variant="head">
                  Сумма
                </StyledTableCell>
                <StyledTableCell align="center">{row.sum}</StyledTableCell>
                <StyledTableCell align="center">{row.sum_name}</StyledTableCell>
                {/* <StyledTableCell align="center">{row.sum_date}</StyledTableCell> */}
                <StyledTableCell align="center">
                  {row.sum_place}
                </StyledTableCell>
              </StyledTableRow>
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
